import React, { useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router'
import styles from '../../../styles/modules/ChildProfile.module.css'
import defaultProfileImg from '../../../assets/images/profile-picture.png';
import { Box, Tab, Tabs } from '@mui/material';
import ChildCuardianTable from './ChildCuardianTable';
import { CoachAPI } from '../../../api/CoachAPI';
import { useSelector } from 'react-redux';
import Loader from '../../../component/Loader';

const ChildProfile = () => {
    document.title = "Kid Profile"
    const { childId } = useParams();
    const userInfo = useSelector((store) => store.user.userInfo);
    const [currentTab, setCurrentTab] = useState(0);
    const [children, setChildren] = useState({});
    const [loadingState, setLoadingState] = useState({
        loading1: false,
        loading2: false,
        loading3: false
    });

    const startLoading = (key) => {
        setLoadingState((prev) => ({
            ...prev, [key]: true
        }))
    };
    const finishLoading = (key) => {
        setLoadingState((prev) => ({
            ...prev, [key]: false
        }))
    };
    const handleTabChange = (event, newValue) => {
        setCurrentTab(newValue);
    }
    const age = useMemo(() => {
        let birthDateStr = children.dob;
        if (!birthDateStr) return null;

        const birthDate = new Date(birthDateStr);
        const today = new Date();

        let age = today.getFullYear() - birthDate.getFullYear();

        const monthDiff = today.getMonth() - birthDate.getMonth();
        const dayDiff = today.getDate() - birthDate.getDate();

        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            age--;
        }

        return age;
    }, [children?.dob]);
    const findChildren = async () => {
        try {
            startLoading("loading1");
            const response = await CoachAPI.findChildrenById(userInfo?.userId, childId);
            setChildren(response.Data);
        } catch (error) {

        } finally {
            finishLoading("loading1");
        }
    }
    useEffect(() => {
        if (userInfo?.userId) {
            findChildren();
        }
    }, [userInfo?.userId])
    
    if(loadingState.loading1){
        return <Loader />;
    }

    return (
        <div className={styles['kid_profile_container']}>
            {loadingState.loading3 && <Loader/>}
            <div className={styles['kid_header_p1']}>
                <svg id="wave" style={{ transform: 'rotate(180deg)', transition: '0.3s' }} viewBox="0 0 1440 220" version="1.1" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="sw-gradient-0" x1="0" x2="0" y1="1" y2="0"><stop stopColor="rgba(127.007, 159.731, 25.601, 1)" offset="0%"></stop><stop stopColor="rgba(184.058, 205.266, 9.719, 1)" offset="100%"></stop></linearGradient></defs><path style={{ transform: 'translate(0, 0px)', opacity: 1 }} fill="url(#sw-gradient-0)" d="M0,22L18.5,47.7C36.9,73,74,125,111,121C147.7,117,185,59,222,51.3C258.5,44,295,88,332,117.3C369.2,147,406,161,443,168.7C480,176,517,176,554,161.3C590.8,147,628,117,665,121C701.5,125,738,161,775,157.7C812.3,154,849,110,886,77C923.1,44,960,22,997,22C1033.8,22,1071,44,1108,51.3C1144.6,59,1182,51,1218,47.7C1255.4,44,1292,44,1329,51.3C1366.2,59,1403,73,1440,66C1476.9,59,1514,29,1551,47.7C1587.7,66,1625,132,1662,132C1698.5,132,1735,66,1772,51.3C1809.2,37,1846,73,1883,80.7C1920,88,1957,66,1994,73.3C2030.8,81,2068,117,2105,139.3C2141.5,161,2178,169,2215,165C2252.3,161,2289,147,2326,124.7C2363.1,103,2400,73,2437,80.7C2473.8,88,2511,132,2548,157.7C2584.6,183,2622,191,2640,194.3L2658.5,198L2658.5,220L2640,220C2621.5,220,2585,220,2548,220C2510.8,220,2474,220,2437,220C2400,220,2363,220,2326,220C2289.2,220,2252,220,2215,220C2178.5,220,2142,220,2105,220C2067.7,220,2031,220,1994,220C1956.9,220,1920,220,1883,220C1846.2,220,1809,220,1772,220C1735.4,220,1698,220,1662,220C1624.6,220,1588,220,1551,220C1513.8,220,1477,220,1440,220C1403.1,220,1366,220,1329,220C1292.3,220,1255,220,1218,220C1181.5,220,1145,220,1108,220C1070.8,220,1034,220,997,220C960,220,923,220,886,220C849.2,220,812,220,775,220C738.5,220,702,220,665,220C627.7,220,591,220,554,220C516.9,220,480,220,443,220C406.2,220,369,220,332,220C295.4,220,258,220,222,220C184.6,220,148,220,111,220C73.8,220,37,220,18,220L0,220Z"></path></svg>
                <div className={styles['kid_image']}>
                    <img src={children?.profileImage ? import.meta.env.VITE_APP_BASE_URL + '/user/user-profile-img/' + children?.profileImage : defaultProfileImg} alt="" />
                </div>
                <div className={styles['kid_details']}>
                    <h1>{(children?.firstName ?? '') + ' ' + (children?.lastName ?? '')}</h1>
                    <h2>Age: {age}</h2>
                    {/* <div className={styles['kid_details_btns']}>
                        <button type='button'>Edit</button>
                        <button type='button'>Delete</button>
                    </div> */}
                </div>
            </div>
            <div className={styles['kid_header_p2']}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs className='money_movement-tabs' value={currentTab} onChange={handleTabChange} aria-label="basic tabs example">
                        <Tab className='money-move-tab'
                            sx={{ fontWeight: 600 }} label="Guadians" />
                    </Tabs>
                </Box>
                {currentTab === 0 && <ChildCuardianTable userInfo={userInfo} childId={childId} startLoading={startLoading} finishLoading={finishLoading} />}
            </div>
        </div>
    )
}

export default ChildProfile